import Chart from "react-apexcharts";
import { fmtInt } from "@/lib/api";
import { apexBase, useChartTheme, PALETTE } from "@/components/production/pcShared";
import { Panel, Empty, ShareBar } from "./biShared";

export default function BiColorsTab({ data }) {
  const dark = useChartTheme();
  const base = apexBase(dark);
  const colors = data.by_color || [];
  const matrix = data.type_color_matrix || { colors: [], rows: [] };
  const maxCell = Math.max(1, ...matrix.rows.flatMap((r) => Object.values(r.cells)));

  return (
    <div className="space-y-3" data-testid="bi-colors-tab">
      <div className="text-[10px] text-zinc-500 border-l-4 border-yellow-400 bg-yellow-50 dark:bg-yellow-900/20 px-3 py-2 rounded" data-testid="bi-colors-note">
        ⚠ O faturamento por COR não existe na base (o valor é registrado por item, não por cor).
        Os números abaixo são em <b>copos</b> — a única métrica real disponível por cor.
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        <Panel title="COPOS VENDIDOS POR COR" testid="bi-chart-colors">
          {colors.length === 0 ? <Empty /> : (
            <Chart type="bar" height={Math.max(200, colors.length * 26)}
              series={[{ name: "Copos", data: colors.map((c) => c.cups) }]}
              options={{
                ...base,
                plotOptions: { bar: { horizontal: true, borderRadius: 3 } },
                xaxis: { categories: colors.map((c) => c.label), labels: { formatter: (v) => fmtInt(v) } },
                colors: [PALETTE[5]],
              }} />
          )}
        </Panel>
        <Panel title="RANKING DE CORES" testid="bi-table-colors">
          {colors.length === 0 ? <Empty /> : (
            <div className="overflow-x-auto">
              <table className="table table-compact">
                <thead>
                  <tr><th>Cor</th><th className="text-right">Copos</th><th className="text-right">Pedidos</th><th>Share</th></tr>
                </thead>
                <tbody>
                  {colors.map((c) => (
                    <tr key={c.label} data-testid={`bi-color-row-${c.label}`}>
                      <td className="font-bold">{c.label}</td>
                      <td className="text-right font-mono">{fmtInt(c.cups)}</td>
                      <td className="text-right font-mono">{fmtInt(c.orders)}</td>
                      <td><ShareBar pct={c.share} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Panel>
      </div>

      <Panel title="MATRIZ TIPO DE COPO × COR (EM COPOS)" testid="bi-matrix">
        {matrix.rows.length === 0 ? <Empty /> : (
          <div className="overflow-x-auto">
            <table className="table table-compact">
              <thead>
                <tr>
                  <th>Tipo</th>
                  {matrix.colors.map((c) => <th key={c} className="text-right">{c}</th>)}
                  <th className="text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                {matrix.rows.map((r) => (
                  <tr key={r.type} data-testid={`bi-matrix-row-${r.type}`}>
                    <td className="font-bold">{r.type}</td>
                    {matrix.colors.map((c) => {
                      const v = r.cells[c] || 0;
                      const alpha = v ? 0.08 + (v / maxCell) * 0.45 : 0;
                      return (
                        <td key={c} className="text-right font-mono"
                          style={alpha ? { backgroundColor: `rgba(43,94,255,${alpha})` } : undefined}>
                          {v ? fmtInt(v) : "·"}
                        </td>
                      );
                    })}
                    <td className="text-right font-mono font-bold">{fmtInt(r.total)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Panel>
    </div>
  );
}
